import styled from "@emotion/styled";
import { ListItemText as MuiListItemText } from "@mui/material";

const ListItemText = styled(MuiListItemText)({
  margin: "0px 0px 0px 0px !important",
  "& .MuiListItemText-primary": {
    fontSize: "20px !important",
    fontWeight: "500 !important",
    padding: "0px 15px !important",
    fontFamily: "Halcom W00 Regular,League Spartan,sans-serif !important",
    lineHeight: "45px !important",
  },
});

export default ListItemText;